export default __webpack_public_path__ + "static/media/newfog5.1bccc041.png";